import { useCallback, useState } from "react";
import { API_ROUTES } from "../../api/routes";
import { GameClient } from "../../api/GameClient";
import { GameState, SettingsData } from "../../types/GameState";
import { AxiosError } from "axios";
import { User } from "../../types/Session";

export const useNewGame = () => {
  const [loading, setLoading] = useState(false);
  const [game, setGame] = useState<GameState>();
  const [error, setError] = useState<AxiosError>();

  const newGame = useCallback(
    async (user: Partial<User>, settings: SettingsData) => {
      setError(undefined);
      setLoading(true);
      try {
        const { data } = await GameClient.post(API_ROUTES.NEW(), {
          ...user,
          settings,
        });
        if (data) {
          setGame(data);
          setLoading(false);
          return data;
        }
      } catch (e) {
        setLoading(false);
        const error = e as AxiosError<any, any>;
        error.message = error.response?.data?.message || error.message;
        setError(e as any);
      }
    },
    []
  );

  return { game, newGame, loading, error };
};
